import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { NotificationActionApi } from '../api/notification-action.api';
import { NotificationActionApplyResult } from '../state/notification.model';

@Injectable({ providedIn: 'root' })
export class NotificationActionService {
  private readonly _notificationActionApi = inject(NotificationActionApi);

  public apply(
    surveyId: string,
    commentId: string,
    actionId: string,
  ): Observable<NotificationActionApplyResult> {
    return this._notificationActionApi.apply(surveyId, commentId, actionId);
  }

  public undo(
    surveyId: string,
    commentId: string,
    actionId: string,
  ): Observable<NotificationActionApplyResult> {
    return this._notificationActionApi.undo(surveyId, commentId, actionId);
  }
}
